import { Input, Label, Modal, useToast } from '@ethsign/ui';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { ColorUserIcon } from '@/components';
import { SKIP_SET_NAME_KEY, SKIP_SET_PASSWORD_MANAGER } from '@/constants';
import { useUserInfo } from '@/hooks';
import { updateUserInfo } from '@/services';
import { ICurrentUser } from '@/types';
import { storageUtil } from '@/utils';

import { SetPasswordManagerModal } from './SetPasswordManagerModal';

export const SetNameModal = ({ user }: { user: ICurrentUser }) => {
  const [open, setOpen] = useState(false);
  const [openPasswordManagerModal, setOpenPasswordManagerModal] = useState(false);
  const { fetchUser } = useUserInfo();
  const [value, onChange] = useState(user?.ens || '');
  const { mutateAsync } = useMutation({
    mutationFn: updateUserInfo,
    mutationKey: ['updateUserInfo']
  });
  const { toast } = useToast();

  const handleOpenPasswordManagerModal = () => {
    const isSkip = storageUtil.get(SKIP_SET_PASSWORD_MANAGER);
    if (user && !user.enableIdentity && !user.identityInitialized && !isSkip) {
      setOpenPasswordManagerModal(true);
    }
  };

  useEffect(() => {
    const isSkip = storageUtil.get(SKIP_SET_NAME_KEY);
    if (user && !user.nickName && !isSkip) {
      setOpen(true);
    } else {
      handleOpenPasswordManagerModal();
    }
  }, [user]);

  const onClose = () => {
    setOpen(false);
  };
  const handleConfirm = async () => {
    await mutateAsync({ nickName: value });
    fetchUser();
    onClose();
    toast({
      title: 'Success',
      description: 'Name updated',
      variant: 'success'
    });
  };

  const onSkip = () => {
    storageUtil.set({
      key: SKIP_SET_NAME_KEY,
      value: true,
      expire: '30_d'
    });
    onClose();
    toast({
      title: 'Success',
      description: 'You can set your name later in Settings',
      variant: 'success'
    });
  };
  return (
    <>
      <Modal
        maskClosable={false}
        open={open}
        onOpenChange={(open) => {
          setOpen(open);
          if (!open) {
            handleOpenPasswordManagerModal();
          }
        }}
        header={
          <>
            <div>
              <ColorUserIcon />
            </div>
            <div className="text-lg font-medium text-gray-900 mt-[20px]">Welcome to EthSign!</div>
            <div className="text-sm text-gray-500 mt-[8px]">
              Before you get started, tell us the name you want to use with EthSign.
            </div>
          </>
        }
        cancelText="Skip"
        onCancel={onSkip}
        confirmText="Confirm"
        onConfirm={handleConfirm}
        confirmButtonProps={{
          variant: 'primary'
        }}
      >
        <div className="mt-[20px]">
          <Label>Name</Label>
          <Input
            placeholder={'Satoshi Nakamoto'}
            className="flex-1 mt-[6px]"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
      </Modal>
      {openPasswordManagerModal && <SetPasswordManagerModal show={openPasswordManagerModal}></SetPasswordManagerModal>}
    </>
  );
};
